<template>
    <div>
        {{ this.event.data.notification }}
    </div>
</template>

<script>
export default {
    name: "Event",
    props: {
        event: {
            type: Object
        }
    },
    data: function() {
        return {}
    },
    computed: {}
}
</script>